function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var normalizeTreeInput = function normalizeTreeInput(_ref) {
  var denormalizedTree = _ref.denormalizedTree,
    _ref$expandedIds = _ref.expandedIds,
    expandedIds = _ref$expandedIds === void 0 ? {} : _ref$expandedIds,
    initialExpandAll = _ref.initialExpandAll,
    _ref$getIdFromNode = _ref.getIdFromNode,
    getIdFromNode = _ref$getIdFromNode === void 0 ? function (node) {
      return node.id;
    } : _ref$getIdFromNode,
    _ref$getLabelFromNode = _ref.getLabelFromNode,
    getLabelFromNode = _ref$getLabelFromNode === void 0 ? function (node) {
      return node.label;
    } : _ref$getLabelFromNode,
    _ref$getChildrenFromN = _ref.getChildrenFromNode,
    getChildrenFromNode = _ref$getChildrenFromN === void 0 ? function (node) {
      return node.children;
    } : _ref$getChildrenFromN;
  var normalizedTree = {};
  var orderedIds = [];
  var internalExpandedIds = {};
  var recurse = function recurse(nodes, normalizedTree) {
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    nodes.forEach(function (node) {
      var id = getIdFromNode(node);
      var children = getChildrenFromNode(node);
      var hasChildren = children && children.length > 0;
      var childIds = hasChildren ? children.map(function (childNode) {
        return getIdFromNode(childNode);
      }) : [];
      var closestParentId = path.length ? path[path.length - 1] : null;
      var hasNoParent = !closestParentId;
      var isParentVisibleAndExpanded = !!closestParentId && !!expandedIds[closestParentId] && !!normalizedTree[closestParentId].show;
      normalizedTree[id] = {
        id: id,
        path: path,
        childIds: childIds,
        label: getLabelFromNode(node),
        show: initialExpandAll || hasNoParent || isParentVisibleAndExpanded,
        original: node
      };
      orderedIds.push(id);
      if (hasChildren) {
        if (initialExpandAll) {
          internalExpandedIds[id] = true;
        }
        path.push(getIdFromNode(node));
        recurse(children, normalizedTree, _toConsumableArray(path));
        path.pop();
      }
    });
  };
  recurse(denormalizedTree, normalizedTree);
  return {
    normalizedTree: normalizedTree,
    orderedIds: orderedIds,
    expandedIds: initialExpandAll ? internalExpandedIds : expandedIds
  };
};
export default normalizeTreeInput;
//# sourceMappingURL=normalizeTreeInput.js.map